export default "__VITE_ASSET__D6ZowxiF__"